import ozCardsContainer from './oz-cards-container'

export default ozCardsContainer
